<template>
  <!-- Main navbar -->
  <div class="navbar navbar-expand-xl navbar-static shadow">
    <div class="container-fluid">
      <div class="navbar-brand flex-1">
        <a href="#" class="d-inline-flex align-items-center">
          <img src="./assets/images/logo-black.svg" alt="" style="height: auto;">
        </a>
      </div>

      <div
        class="d-flex w-100 w-xl-auto overflow-auto overflow-xl-visible scrollbar-hidden border-top border-top-xl-0 order-1 order-xl-0 pt-2 pt-xl-0 mt-2 mt-xl-0">
        <ul class="nav gap-1 justify-content-center flex-nowrap flex-xl-wrap mx-auto">
          <li class="nav-item">
            <a href="https://xn--80abemxrdfbrfhmbe5d.xn--p1ai/" class="navbar-nav-link rounded fw-semibold">
              На сайт
            </a>
          </li>
          <li class="nav-item">
            <router-link to="instruction" class="navbar-nav-link rounded fw-semibold">Инструкция</router-link>
          </li>
          <li
            v-if="form.formInWork"
            class="nav-item nav-item-dropdown-lg dropdown">
            <a href="#" class="navbar-nav-link dropdown-toggle rounded fw-semibold" data-bs-toggle="dropdown" aria-expanded="false">
              Шаги
            </a>
            <div class="dropdown-menu">
							<div class="dropdown-header">Шаги заявления</div>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step1')">1. Персональные данные</a>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step2')">2. Собственность</a>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step3')">3. ПРОДАЖА ИМУЩЕСТВА</a>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step4')">4. СЕМЕЙНОЕ ПОЛОЖЕНИЕ</a>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step5')">5. ТРУДОУСТРОЙСТВО</a>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step6')">6. СВЕДЕНИЯ О КРЕДИТОРАХ И ДОЛЖНИКАХ</a>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step7')">7. Судебные процессы</a>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step8')">8. Исполнительные производства</a>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step9')">9. Выбор СРО</a>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step10')">10. Внесение ДС на счет суда</a>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step11')">11. Список необходимых документов</a>
              <a href="#" class="dropdown-item rounded" @click.prevent="toStep('step12')">12. Итоговый документ</a>
						</div>
          </li>
          <li v-if="form.formInWork" class="nav-item">
            <a href="#" class="navbar-nav-link rounded fw-semibold" @click.prevent="toStep('step11')">
              Документы
            </a>
          </li>
          <li v-if="form.formInWork" class="nav-item">
            <a href="#" class="navbar-nav-link rounded fw-semibold" @click.prevent="toStep('step12')">
              Заявление
            </a>
          </li>
        </ul>
      </div>

      <ul class="nav gap-1 flex-xl-1 justify-content-end order-0 order-xl-1">
        <li class="nav-item nav-item-dropdown-xl dropdown">
          <div class="phone sticky me-2">
            <svg width="15" height="15" viewBox="0 0 12 13" fill="#2B2B2B"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.6484 8.98438C11.8828 9.07812 12 9.25 12 9.5C12 9.54688 11.9922 9.58594 11.9766 9.61719L11.4141 12.0547C11.3984 12.1328 11.3594 12.2031 11.2969 12.2656C11.25 12.3438 11.1875 12.3984 11.1094 12.4297C11.0312 12.4766 10.9531 12.5 10.875 12.5C7.875 12.5 5.3125 11.4375 3.1875 9.3125C1.0625 7.1875 0 4.625 0 1.625C0 1.54688 0.015625 1.46875 0.046875 1.39062C0.09375 1.3125 0.148438 1.25 0.210938 1.20312C0.289062 1.14062 0.367188 1.10156 0.445312 1.08594L2.88281 0.523438C2.91406 0.507812 2.95312 0.5 3 0.5C3.25 0.5 3.42188 0.617188 3.51562 0.851562L4.64062 3.47656C4.67188 3.53906 4.6875 3.60938 4.6875 3.6875C4.6875 3.85938 4.61719 4.00781 4.47656 4.13281L3.07031 5.28125C3.42969 6.0625 4.01562 6.85938 4.82812 7.67188C5.64062 8.48438 6.4375 9.07031 7.21875 9.42969L8.36719 8.02344C8.49219 7.88281 8.64062 7.8125 8.8125 7.8125C8.89062 7.8125 8.96094 7.82812 9.02344 7.85938L11.6484 8.98438Z">
              </path>
            </svg> <a href="tel:8-800-2012-911" class="text-body ms-1 fw-semibold">8-800-2012-911</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <!-- /main navbar -->

  <!-- Page content -->
  <div class="page-content" style="background-color: white">
    <!-- Main content -->
    <div class="content-wrapper">
      <!-- Inner content -->
      <div class="content-inner">
        <!-- Content area -->
        <div class="content pt-0">
          <RouterView></RouterView>
        </div>
        <!-- /content area -->
      </div>
      <!-- /inner content -->
      <!-- Footer 1 -->
      <div class="navbar navbar-sm navbar-footer p-1" v-if="currentRouteName !== 'admin'">
          <div
            v-if="subForm === 'main'"
            class="container-fluid text-center mb-2">
            <div class="navbar-brand"></div>
            <div
              v-if="thisStep.stepNumber > 0"
              class="hstack gap-2 mt-3 mt-sm-0">
                <button
                  v-if="prevStep.stepName"
                  @click="toprevStep()"
                  type="button" class="btn btn-danger rounded-pill me-1 px-3 finexbutton">
                    {{ prevStep.stepName }}
                </button>
                <button
                  v-if="nextStep.stepName"
                  @click="tonextStep()"
                  type="button" class="btn btn-danger rounded-pill px-3 finexbutton">
                  {{ nextStep.stepName }}
                </button>
            </div>
            <div class="navbar-brand"></div>
          </div>
        </div>
        <!-- /footer -->
       <!-- Footer -->
       <div class="navbar navbar-sm navbar-footer border-top p-1">
          <div class="container-fluid">
            <span>&copy; 2025 <a href="https://банкротствоцентр.рф" class="text-body fw-semibold">ООО "ФИНЭКС"</a></span>
            <span class="d-none d-lg-block" v-if="thisStep.stepNumber > 0">Сейчас Вы тут: {{ thisStep.stepName }}, дальше - {{ nextStep.stepName }}</span>
            <ul class="nav">
              <li class="nav-item ms-md-1">
                <a href="https://банкротствоцентр.рф/#formX3va1X" class="navbar-nav-link navbar-nav-link-icon rounded"
                   target="_blank">
                  <div class="d-flex align-items-center mx-md-1">
                    <i class="ph-file-text"></i>
                    <span class="d-none d-md-inline-block ms-2">Политика конфиденциальности</span>
                  </div>
                </a>
              </li>
              <li class="nav-item ms-md-1">
                <div>
                    <button type="button" class="btn btn-light" @click.prevent="toAdminSection">A</button>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- /footer -->
    </div>
    <!-- /main content -->
  </div>
  <!-- /page content -->

  <!-- Demo config -->
  <div v-if="form.formInWork" class="offcanvas offcanvas-end" tabindex="-1" id="demo_config">
    <div class="position-absolute top-50 end-100 visible">
      <button type="button" class="btn btn-primary btn-icon translate-middle-y rounded-end-0" data-bs-toggle="offcanvas" data-bs-target="#demo_config">
        <i class="ph-gear"></i>
      </button>
    </div>

    <div class="offcanvas-header border-bottom py-0">
      <h5 class="offcanvas-title py-3">Быстрая навигация</h5>
      <button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill"
              data-bs-dismiss="offcanvas">
        <i class="ph-x"></i>
      </button>
    </div>

    <div class="offcanvas-body">
      <router-link to="instruction" class="navbar-nav-link rounded fw-semibold mb-3">Инструкция по подаче заявления</router-link>
      <div class="fw-semibold mb-2">Шаги заявления</div>
      <div class="list-group list-group-borderless">
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step1')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">1. Персональные данные</a>
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step2')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">2. Собственность</a>
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step3')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">3. ПРОДАЖА ИМУЩЕСТВА</a>
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step4')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">4. СЕМЕЙНОЕ ПОЛОЖЕНИЕ</a>
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step5')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">5. ТРУДОУСТРОЙСТВО</a>
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step6')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">6. СВЕДЕНИЯ О КРЕДИТОРАХ И ДОЛЖНИКАХ</a>
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step7')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">7. Судебные процессы</a>
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step8')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">8. Исполнительные производства</a>
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step9')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">9. Выбор СРО</a>
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step10')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">10. Внесение ДС на счет суда</a>
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step11')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">11. Список необходимых документов</a>
          <a href="#" class="list-group-item text-body finexlink" @click.prevent="toStep('step12')" data-bs-toggle="offcanvas" data-bs-target="#demo_config">12. Итоговый документ</a>
      </div>
    </div>

    <div class="border-top text-center py-2 px-3">
      <a href="https://банкротствоцентр.рф/#formX3va1X"
         class="btn btn-yellow fw-semibold w-100 my-1" target="_blank">
        Полчить консультацию
      </a>
    </div>
  </div>
  <!-- /demo config -->
</template>

<script>

import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

export default {
  name: 'UsersView',
  components: {
  },
  setup () {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const currentRouteName = computed(() => route.name)
    const currentRoute = router.currentRoute

    const form = computed(() => store.getters.form)
    const thisStep = computed(() => form.value[currentRoute.value.name] || form.value[form.value.currentStep] || {})
    const prevStep = computed(() => form.value[thisStep.value.prevStep] || {})
    const nextStep = computed(() => form.value[thisStep.value.nextStep] || {})


    const loadData = async function () {
      await store.dispatch('mainLoad')
      const lastStep = localStorage.getItem('step')
      if (lastStep) store.commit('setStep', lastStep)
      router.push({
        name: lastStep && form.value[lastStep] ? lastStep : 'step0'
      })
      // showToast('Данные загружены')
    }

    const toAdminSection = async function () {
      router.push({name: 'admin'})
    }

    const toprevStep = async function () {
      await store.dispatch('saveForm')
      const toStep = form.value[form.value.currentStep]?.prevStep || 'step0'
      store.commit('setStep', toStep)
      router.push({ name: toStep })
      // showToast('Данные сохранены')
    }

    const tonextStep = async function () {
      await store.dispatch('saveForm')
      const toStep = form.value[form.value.currentStep]?.nextStep || 'step0'
      store.commit('setStep', toStep)
      router.push({ name: toStep })
      // showToast('Данные сохранены')
    }

    const toStep = async function (stepName = 'step0') {
      await store.dispatch('saveForm')
      store.commit('setStep', stepName)
      router.push({ name: stepName })
      // showToast('Данные сохранены')
    }

    const showToast = function (msg) {
      toast(msg.text || msg, {
        autoClose: 3000,
        type: msg.type || 'default',
        position: 'top-center'
      })
    }

    return {
      loadData,
      toprevStep,
      tonextStep,
      thisStep,
      prevStep,
      nextStep,
      toStep,
      subForm: computed(() => store.state.subForm),
      currentRouteName,
      toAdminSection,
      form
    }
  },
  created () {
    const route = useRoute()
    const currentRouteName = computed(() => route.name)
    if (localStorage.getItem('phone') && currentRouteName.value !== 'admin') this.loadData()
  }
}
</script>

<style>
.finexbutton {
    display: inline-block;
    background: #CC0033;
    color: #FFFFFF;
    border-radius: 32px;
    text-decoration: none;
    text-transform: uppercase;
    padding: 10px 35px;
    border: 2px solid #CC0033;
    font: normal 700 12px / 18px 'Roboto', sans-serif;
    -webkit-transition: background-color .5s, color .5s, border .5s;
    transition: background-color .5s, color .5s, border .5s;
    cursor: pointer;
    outline: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    letter-spacing: 0.08em;
}
.finexlink {
    color: #CC0033;
}
.finexbutton:hover {
  background-color: transparent;
  color: #CC0033;
  border-color: #CC0033;
}
.finexlink:hover {
  color: #79011f;
}
.finexbutton.is-outlined {
  background-color: transparent;
  color: #CC0033;
}
.finexbutton.is-outlined:hover {
  background: #CC0033;
  color: #FFFFFF;
  border-color: #CC0033;
}
.button.is-loading {
  color: transparent !important;
  pointer-events: none;
  background: #CC0033 !important;
  border-color: #CC0033 !important;
  position: relative;
}

@media screen and (max-width: 800px) {
  table.subFormTable thead {
    display: none;
  }
  table.subFormTable tr {
    display: block;
  }
  table.subFormTable td {
    display: block;
    text-align: right;
    border-width: 0;
  }
  table.subFormTable td:before {
    content: attr(aria-label);
    float: left;
    font-weight: bold;
  }
}
</style>
